// Function to generate section data
const getSectionData = (id, section, selector) => ({ id, section, selector });

// Check cart drawer and set sections to render
const cartDrawer = document.querySelector('cart-drawer');
let sectionsToRender = [];

if (cartDrawer) {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(
        `#shopify-section-${mainCartId}`,
        mainCartId,
        `#shopify-section-${mainCartId} cart-items`
      ),
      getSectionData(
        '#cart-counter',
        'cart-counter',
        '#shopify-section-cart-counter'
      ),
      getSectionData(
        '#CartDrawer-Body',
        'cart-drawer',
        '#shopify-section-cart-drawer #CartDrawer-Body'
      ),
    ];
  } else {
    sectionsToRender = [
      getSectionData(
        '#CartDrawer-Body',
        'cart-drawer',
        '#shopify-section-cart-drawer #CartDrawer-Body'
      ),
    ];
  }
} else {
  const mainCartId = document.getElementById('main-cart-items')?.dataset.id;
  if (mainCartId) {
    sectionsToRender = [
      getSectionData(
        `#shopify-section-${mainCartId}`,
        mainCartId,
        `#shopify-section-${mainCartId} cart-items`
      ),
      getSectionData(
        '#cart-counter',
        'cart-counter',
        '#shopify-section-cart-counter'
      ),
    ];
  } else {
    sectionsToRender = [];
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') || this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
      updateFreeShipping();
    });
  }
}
customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.freeShipping = document.querySelectorAll('shipping-bar');

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener('change', this.debouncedOnChange.bind(this));

    updateFreeShipping();
  }

  calculateTotalItemCount(items) {
    return items.reduce((total, item) => total + item.quantity, 0);
  }

  onChange(event) {
    if (event.target.name !== 'updates[]') return;

    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name')
    );
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  updateQuantity(line, quantity, name) {
    this.classList.add('is-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      ...{ body },
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.getSectionsToRender()?.forEach((section) => {
          const elementToReplace =
            document.querySelector(section.selector) ||
            document.querySelector(section.id);

          if (elementToReplace) {
            if (!parsedState.errors) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            }
          } else {
            console.error(
              `Element with selector ${section.selector} not found`
            );
          }
        });
        if (!parsedState.errors) {
          this.totalItemCount = this.calculateTotalItemCount(parsedState.items);
        }
        this.updateLiveRegions(
          line,
          parsedState.item_count,
          parsedState.errors
        );

        const lineItem = document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`))
          lineItem.querySelector(`[name="${name}"]`).focus();

        updateCartCounters();
        updateFreeShipping();
      })
      .finally(() => this.classList.remove('is-loading'));
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  updateLiveRegions(line, itemCount, parsedError) {
    if (parsedError) {
      document
        .querySelectorAll(`[data-line-item-error][data-line="${line}"]`)
        .forEach((error) => {
          error.innerHTML = parsedError;
        });
    }

    this.currentItemCount = itemCount;
  }
}
customElements.define('cart-items', CartItems);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.setCartLink();
    this.parentElement.addEventListener('shopify:section:select', () =>
      this.open()
    );
    this.parentElement.addEventListener('shopify:section:deselect', () =>
      this.close()
    );
  }

  setCartLink() {
    const cartLink = document.querySelector('[data-cart-link]');
    if (cartLink) {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() !== 'SPACE') return;
        event.preventDefault();
        this.open(cartLink);
      });
    } else {
      console.error('Cart link not found');
    }
  }

  open(opener) {
    if (opener) this.setActiveElement(opener);
    this.classList.add('is-visible');
    document.querySelector('body').style.overflow = 'hidden';
    this.addEventListener(
      'transitionend',
      () => {
        this.focusOnCartDrawer();
      },
      { once: true }
    );

    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick);
    }, 100);

    // Trigger product recommendations to fetch when cart drawer opens
    setTimeout(() => {
      const productRecommendations = this.querySelector(
        '.product-recommendations'
      );
      if (
        productRecommendations &&
        productRecommendations.dataset.recommendationArea === 'cart-drawer'
      ) {
        // Force re-initialization if connectedCallback hasn't run yet
        if (
          productRecommendations.classList.contains('hidden') &&
          productRecommendations.dataset.url
        ) {
          const recommendations = productRecommendations.querySelector(
            '[data-recommendations]'
          );
          if (recommendations) {
            fetch(productRecommendations.dataset.url)
              .then((response) => {
                if (!response.ok) return null;
                return response.text();
              })
              .then((text) => {
                if (!text) return;
                const recommendationsHTML = new DOMParser()
                  .parseFromString(text, 'text/html')
                  .querySelector('[data-recommendations]')?.innerHTML;
                if (recommendationsHTML && recommendationsHTML.trim() !== '') {
                  productRecommendations.classList.remove('hidden');
                  const cartDrawerItemsFull = document.querySelector(
                    '.cart-drawer-items__full'
                  );
                  if (cartDrawerItemsFull) {
                    cartDrawerItemsFull.classList.remove(
                      'cart-drawer-items__full'
                    );
                  }
                  recommendations.innerHTML = recommendationsHTML;
                  // Initialize slider if Swiper is available
                  if (
                    window.Swiper &&
                    productRecommendations.querySelector('.swiper')
                  ) {
                    new Swiper(
                      productRecommendations.querySelector('.swiper'),
                      {
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                      }
                    );
                  }
                }
              })
              .catch((error) =>
                console.error('Error fetching product recommendations:', error)
              );
          }
        }
      }

      // Update layout based on recommendations visibility
      const productReccomendations = document.querySelector(
        '.product-recommendations'
      );
      if (productReccomendations) {
        if (productReccomendations.classList.contains('hidden')) {
          document
            .querySelector('.cart-drawer-items')
            ?.classList.add('cart-drawer-items__full');
        } else {
          document
            .querySelector('.cart-drawer-items')
            ?.classList.remove('cart-drawer-items__full');
        }
      }
    }, 300);
  }

  close() {
    this.classList.remove('is-visible');
    document.querySelector('body').style.overflow = 'auto';
    removeTrapFocus(this.activeElement);

    document.removeEventListener('click', this.handleOutsideClick);

    const isHeaderMenuOpen = header.classList.contains('menu-open');

    if (isHeaderMenuOpen) {
      return;
    }

    // if we are on the cart page, resubmit form
    if (window.location.pathname === '/cart') {
      const cartDrawerForm = document.getElementById('CartDrawer-FormSummary');
      if (cartDrawerForm) {
        cartDrawerForm.submit();
      }
    }
  }

  handleOutsideClick = (event) => {
    const cartDrawerInner = this.querySelector('.cart-drawer__inner');
    if (cartDrawerInner && !cartDrawerInner.contains(event.target)) {
      this.close();
    }
  };

  setActiveElement(element) {
    this.activeElement = element;
  }

  focusOnCartDrawer() {
    const containerToTrapFocusOn = this.firstElementChild;
    const focusElement = this.querySelector('[data-drawer-close]');
    trapFocus(containerToTrapFocusOn, focusElement);
  }

  renderContents(response, open = true) {
    this.getSectionsToRender()?.forEach((section) => {
      const sectionElement = document.querySelector(section.id);
      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector
      );

      updateCartCounters();
    });
    if (!open) {
      return;
    }

    this.open();
  }

  getSectionsToRender() {
    return sectionsToRender;
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}
customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return sectionsToRender;
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);

// Handle discount code form submission in cart drawer
function handleDiscountFormSubmit(event) {
  event.preventDefault();
  event.stopPropagation();

  const form = event.target;
  // Only handle discount forms, not the checkout form
  if (!form.hasAttribute('data-discount-form')) return;

  const cartDrawer = form.closest('cart-drawer');
  if (!cartDrawer) return;

  const submitButton = form.querySelector('button[type="submit"]');
  const applyText = submitButton?.querySelector(
    '.cart-drawer__discount-apply-text'
  );
  const applySpinner = submitButton?.querySelector(
    '.cart-drawer__discount-apply-spinner'
  );

  // Show spinner and hide text (but keep it in layout to maintain button width)
  if (submitButton) {
    submitButton.disabled = true;
    if (applyText) applyText.classList.add('hidden');
    if (applySpinner) applySpinner.style.display = 'flex';
  }

  // Get discount code value
  const discountCode = form
    .querySelector('input[name="discount"]')
    .value.trim();
  if (!discountCode) {
    alert('Please enter a discount code');
    if (submitButton) {
      submitButton.disabled = false;
      if (applyText) applyText.classList.remove('hidden');
      if (applySpinner) applySpinner.style.display = 'none';
    }
    return;
  }

  // Check if routes is defined
  if (typeof routes === 'undefined' || !routes.cart_url) {
    console.error('Routes not defined');
    alert('There was an error applying your discount code. Please try again.');
    if (submitButton) {
      submitButton.disabled = false;
      if (applyText) applyText.classList.remove('hidden');
      if (applySpinner) applySpinner.style.display = 'none';
    }
    return;
  }

  // Use Shopify's discount endpoint via hidden iframe
  // The /discount/{code} endpoint applies discounts when accessed
  const currentPath = window.location.pathname;
  const discountUrl = `/discount/${encodeURIComponent(
    discountCode
  )}?redirect=${encodeURIComponent(currentPath)}`;

  console.log('Applying discount code via:', discountUrl);

  // Create hidden iframe to navigate to discount URL
  const iframe = document.createElement('iframe');
  iframe.style.cssText =
    'position:absolute;top:-9999px;left:-9999px;width:1px;height:1px;border:none;visibility:hidden;';
  iframe.src = discountUrl;
  document.body.appendChild(iframe);

  // Update cart UI after discount is processed
  const updateCartUI = () => {
    // Clean up iframe
    setTimeout(() => {
      if (iframe.parentNode) {
        iframe.parentNode.removeChild(iframe);
      }
    }, 1000);

    // Fetch updated sections
    const sectionIds = sectionsToRender.map((s) => s.section).join(',');
    const sectionsUrl = `${routes.cart_url}?sections=${sectionIds}`;

    return fetch(sectionsUrl, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
    })
      .then((response) => response.json())
      .then((sectionsData) => {
        // Update cart drawer
        const cartDrawerElement = document.querySelector('cart-drawer');
        if (cartDrawerElement && cartDrawerElement.renderContents) {
          const wrappedResponse = { sections: sectionsData };
          cartDrawerElement.renderContents(wrappedResponse, false);
        }

        // Update counters
        setTimeout(() => {
          updateCartCounters();
          updateFreeShipping();
        }, 100);

        // Re-initialize forms
        const newForms = document.querySelectorAll('[data-discount-form]');
        newForms.forEach((newForm) => {
          if (!newForm.dataset.initialized) {
            newForm.addEventListener('submit', handleDiscountFormSubmit);
            newForm.dataset.initialized = 'true';
          }
        });

        // Restore button - hide spinner and show text
        if (submitButton) {
          submitButton.disabled = false;
          if (applyText) applyText.classList.remove('hidden');
          if (applySpinner) applySpinner.style.display = 'none';
        }
      })
      .catch((error) => {
        console.error('Error updating sections:', error);
        handleDiscountError('Error updating cart.');
      });
  };

  // Wait a moment for Shopify to process the discount, then update the cart
  // This delay gives Shopify enough time to apply the discount via the iframe
  setTimeout(() => {
    updateCartUI();
  }, 1500); // 1.5 second delay for discount processing

  const handleDiscountError = (message) => {
    alert(message);
    if (iframe.parentNode) {
      iframe.parentNode.removeChild(iframe);
    }
    // Restore button - hide spinner and show text
    if (submitButton) {
      submitButton.disabled = false;
      if (applyText) applyText.classList.remove('hidden');
      if (applySpinner) applySpinner.style.display = 'none';
    }
  };
}

// Initialize discount forms on page load
document.addEventListener('DOMContentLoaded', () => {
  initializeDiscountForms();
});

function initializeDiscountForms() {
  const discountForms = document.querySelectorAll('[data-discount-form]');
  discountForms.forEach((form) => {
    if (!form.dataset.initialized) {
      form.addEventListener('submit', handleDiscountFormSubmit);
      form.dataset.initialized = 'true';
    }
  });
}

// Also initialize when cart drawer content is updated
const observer = new MutationObserver(() => {
  initializeDiscountForms();
  initializeCheckoutForm();
});

// Ensure checkout form works - initialize when DOM is ready
function initializeCheckoutForm() {
  const checkoutForm = document.getElementById('CartDrawer-FormSummary');
  if (checkoutForm) {
    const checkoutButton = checkoutForm.querySelector(
      'button[name="checkout"], button[data-checkout-button]'
    );
    if (checkoutButton && !checkoutButton.dataset.checkoutInitialized) {
      checkoutButton.dataset.checkoutInitialized = 'true';

      // Handle checkout button click directly
      checkoutButton.addEventListener(
        'click',
        (event) => {
          const form = checkoutButton.closest('form');
          if (form && form.id === 'CartDrawer-FormSummary') {
            // Check if terms checkbox is required and checked
            const termsCheckbox = form.querySelector('#Terms-Conditions');
            if (
              termsCheckbox &&
              termsCheckbox.required &&
              !termsCheckbox.checked
            ) {
              // Let browser handle validation
              return;
            }

            // Stop any event propagation that might interfere
            event.stopImmediatePropagation();

            // Submit the form directly - this will redirect to checkout
            form.submit();
          }
        },
        true
      ); // Use capture phase to run before other handlers
    }
  }
}

// Restructure checkout+ layout
function restructureCheckoutPlus() {
  const actionButtons = document.querySelector('.cart-drawer__action-buttons');
  if (!actionButtons) {
    // Retry if cart drawer not open yet
    setTimeout(restructureCheckoutPlus, 300);
    return;
  }

  const redoToggle = actionButtons.querySelector('redo-shopify-toggle');
  if (!redoToggle) {
    // Retry if checkout+ not loaded yet
    setTimeout(restructureCheckoutPlus, 300);
    return;
  }

  // Wait for shadow DOM to be fully injected by the checkout+ app
  function waitForShadowDOM(attempts = 0, maxAttempts = 20) {
    if (attempts >= maxAttempts) {
      console.warn('Checkout+ shadow DOM did not load after maximum attempts');
      return;
    }

    try {
      const shadowRoot = redoToggle.shadowRoot;
      if (!shadowRoot) {
        // Shadow DOM not attached yet
        setTimeout(() => waitForShadowDOM(attempts + 1, maxAttempts), 200);
        return;
      }

      const infoCardContainer = shadowRoot.querySelector(
        '[data-target="info-card-container"]'
      );
      const checkoutButtonsContainer = shadowRoot.querySelector(
        '[data-target="checkout-buttons-container"]'
      );

      // Check if containers exist AND have content (not just empty containers)
      const hasInfoContent =
        infoCardContainer && infoCardContainer.children.length > 0;
      const hasButtonContent =
        checkoutButtonsContainer &&
        (checkoutButtonsContainer.children.length > 0 ||
          checkoutButtonsContainer.querySelector('button') !== null ||
          checkoutButtonsContainer.querySelector(
            '[data-target="coverage-button"]'
          ) !== null);

      if (
        !infoCardContainer ||
        !checkoutButtonsContainer ||
        !hasInfoContent ||
        !hasButtonContent
      ) {
        // Shadow DOM exists but not fully populated yet
        setTimeout(() => waitForShadowDOM(attempts + 1, maxAttempts), 200);
        return;
      }

      // Shadow DOM is ready! Proceed with restructure
      const actionButtons = document.querySelector(
        '.cart-drawer__action-buttons'
      );
      performRestructure(
        shadowRoot,
        infoCardContainer,
        checkoutButtonsContainer,
        actionButtons
      );
    } catch (error) {
      console.warn('Error waiting for checkout+ shadow DOM:', error);
      setTimeout(() => waitForShadowDOM(attempts + 1, maxAttempts), 200);
    }
  }

  // Start waiting for shadow DOM
  waitForShadowDOM();
}

// Perform the actual restructuring once shadow DOM is ready
function performRestructure(
  shadowRoot,
  infoCardContainer,
  checkoutButtonsContainer,
  actionButtons
) {
  try {
    // Don't mark as restructured so we can re-run if needed
    // The function will handle duplicate checks internally

    // Inject styles into shadow DOM to restructure layout
    let styleElement = shadowRoot.querySelector(
      'style[data-checkout-plus-restructure]'
    );
    if (!styleElement) {
      styleElement = document.createElement('style');
      styleElement.setAttribute('data-checkout-plus-restructure', 'true');
      shadowRoot.appendChild(styleElement);
    }

    // Style the shadow DOM - hide button in original (only show info card)
    styleElement.textContent = `
        :host {
          display: flex !important;
          flex-direction: column !important;
          gap: 1.2rem !important;
          width: 100% !important;
        }
        [data-target="info-card-container"] {
          width: 100% !important;
          flex: 1 0 auto !important;
          margin-bottom: 0 !important;
          display: flex !important;
        }
        [data-target="checkout-buttons-container"] {
          display: flex !important;
          flex-direction: row !important;
          gap: 1.2rem !important;
          width: 100% !important;
        }
        [data-target="non-coverage-button"],
        [data-target="non-coverage-button"] *,
        [data-target="non-coverage-button"] > p,
        [data-target="non-coverage-button"] p,
        button[data-target="non-coverage-button"],
        button[data-target="non-coverage-button"] p,
        button[data-target="non-coverage-button"] > p {
          color: #000 !important;
        }
        [data-target="non-coverage-button"],
        [data-target="non-coverage-button"] *,
        [data-target="non-coverage-button"] > p,
        [data-target="non-coverage-button"] p,
        button[data-target="non-coverage-button"],
        button[data-target="non-coverage-button"] *,
        button[data-target="non-coverage-button"] > p,
        [data-target="non-coverage-button"]:hover,
        [data-target="non-coverage-button"]:hover *,
        [data-target="non-coverage-button"]:hover > p,
        [data-target="non-coverage-button"]:hover p,
        button[data-target="non-coverage-button"]:hover,
        button[data-target="non-coverage-button"]:hover *,
        button[data-target="non-coverage-button"]:hover > p {
          color: #000 !important;
        }
      `;

    // Strategy: Move view cart button into checkout+ shadow DOM's checkout-buttons-container
    // This will naturally put them side by side since the container likely uses flexbox

    // Find the view cart button - try multiple selectors
    const viewCartButton =
      actionButtons &&
      (actionButtons.querySelector('a.button[href*="/cart"]') ||
        actionButtons.querySelector('a[href*="/cart"]') ||
        actionButtons.querySelector('a.button'));

    console.log('View cart button found:', !!viewCartButton);
    console.log(
      'Checkout buttons container found:',
      !!checkoutButtonsContainer
    );

    if (viewCartButton && checkoutButtonsContainer) {
      // Function to insert view cart button
      const insertViewCartButton = () => {
        // Check if view cart button is already in shadow DOM
        const existingViewCart = checkoutButtonsContainer.querySelector(
          'a[href*="/cart"], a.button[href*="/cart"]'
        );

        if (!existingViewCart) {
          console.log('Inserting view cart button into shadow DOM');

          // Clone the view cart button to move into shadow DOM
          // (can't move actual element, but clone works)
          const clonedViewCart = viewCartButton.cloneNode(true);

          // Remove full width styling
          clonedViewCart.classList.remove('button--full');
          clonedViewCart.style.cssText = `
            width: auto !important;
            flex: 1 1 50% !important;
            min-width: 0 !important;
            display: inline-block !important;
          `;

          // Insert at the beginning of checkout-buttons-container (left side)
          // Use a small delay to ensure container is ready
          setTimeout(() => {
            try {
              checkoutButtonsContainer.insertBefore(
                clonedViewCart,
                checkoutButtonsContainer.firstChild
              );
              console.log('View cart button inserted successfully');

              // Hide the original view cart button since we have it in shadow DOM now
              viewCartButton.style.display = 'none';

              // Ensure checkout-buttons-container uses flexbox for side-by-side layout
              checkoutButtonsContainer.style.cssText += `
                display: flex !important;
                flex-direction: row !important;
                gap: 1.2rem !important;
                width: 100% !important;
              `;
              console.log('Applied flexbox styles to container');
            } catch (error) {
              console.error('Error inserting view cart button:', error);
            }
          }, 50);
        } else {
          console.log('View cart button already exists in shadow DOM');
        }
      };

      // Try to insert immediately
      insertViewCartButton();

      // Also try after a short delay in case container structure changes
      setTimeout(insertViewCartButton, 100);
      setTimeout(insertViewCartButton, 300);

      // Style children to be equal width - update CSS in shadow DOM
      const styleForContainer = shadowRoot.querySelector(
        'style[data-checkout-buttons-layout]'
      );
      if (!styleForContainer) {
        const containerStyle = document.createElement('style');
        containerStyle.setAttribute('data-checkout-buttons-layout', 'true');
        containerStyle.textContent = `
          [data-target="checkout-buttons-container"] {
            display: flex !important;
            flex-direction: row !important;
            gap: 1.2rem !important;
            width: 100% !important;
          }
          [data-target="checkout-buttons-container"] > * {
            flex: 1 1 50% !important;
            min-width: 0 !important;
            box-sizing: border-box !important;
          }
          [data-target="checkout-buttons-container"] > a,
          [data-target="checkout-buttons-container"] > a.button {
            flex: 1 1 50% !important;
            min-width: 0 !important;
            width: auto !important;
            display: inline-block !important;
          }
          [data-target="checkout-buttons-container"] > button {
            flex: 1 1 50% !important;
            min-width: 0 !important;
          }
        `;
        shadowRoot.appendChild(containerStyle);
      } else {
        // Update existing style
        styleForContainer.textContent = `
          [data-target="checkout-buttons-container"] {
            display: flex !important;
            flex-direction: row !important;
            gap: 1.2rem !important;
            width: 100% !important;
          }
          [data-target="checkout-buttons-container"] > * {
            flex: 1 1 50% !important;
            min-width: 0 !important;
            box-sizing: border-box !important;
          }
          [data-target="checkout-buttons-container"] > a,
          [data-target="checkout-buttons-container"] > a.button {
            flex: 1 1 50% !important;
            min-width: 0 !important;
            width: auto !important;
            display: inline-block !important;
          }
          [data-target="checkout-buttons-container"] > button {
            flex: 1 1 50% !important;
            min-width: 0 !important;
          }
        `;
      }
    } else {
      console.warn('View cart button or checkout buttons container not found');
    }

    // Add global CSS for layout (ensure view cart buttons in shadow DOM are styled)
    const additionalStyle = document.createElement('style');
    additionalStyle.textContent = `
      redo-shopify-toggle [data-target="checkout-buttons-container"] > a.button {
        flex: 1 1 50% !important;
        min-width: 0 !important;
      }
    `;
    if (!document.head.querySelector('style[data-checkout-plus-global]')) {
      additionalStyle.setAttribute('data-checkout-plus-global', 'true');
      document.head.appendChild(additionalStyle);
    }

    // Watch for non-coverage-button and style it when it appears
    const styleNonCoverageButton = () => {
      const nonCoverageButton = shadowRoot.querySelector(
        '[data-target="non-coverage-button"]'
      );
      if (nonCoverageButton) {
        // Style the button itself
        nonCoverageButton.style.color = '#000';
        nonCoverageButton.style.setProperty('color', '#000', 'important');

        // Style all children including p elements
        const allElements = nonCoverageButton.querySelectorAll('*');
        allElements.forEach((el) => {
          el.style.color = '#000';
          el.style.setProperty('color', '#000', 'important');
        });

        // Also target p elements specifically, especially direct children
        const pElements = nonCoverageButton.querySelectorAll('p');
        pElements.forEach((p) => {
          p.style.color = '#000';
          p.style.setProperty('color', '#000', 'important');
        });

        // Specifically target direct child p elements (most specific selector)
        const directChildP = nonCoverageButton.querySelector(':scope > p');
        if (directChildP) {
          directChildP.style.color = '#000';
          directChildP.style.setProperty('color', '#000', 'important');
        }

        // If it's a button, style it directly
        if (nonCoverageButton.tagName === 'BUTTON') {
          nonCoverageButton.style.color = '#000';
          nonCoverageButton.style.setProperty('color', '#000', 'important');
        }
      }
    };

    // Try to style immediately and repeatedly until found
    styleNonCoverageButton();

    // Try multiple times as the element might load later
    let attempts = 0;
    const maxAttempts = 10;
    const styleInterval = setInterval(() => {
      attempts++;
      styleNonCoverageButton();
      if (attempts >= maxAttempts) {
        clearInterval(styleInterval);
      }
    }, 200);

    // Watch for shadow DOM changes (in case checkout+ app updates it)
    const shadowDOMObserver = new MutationObserver((mutations) => {
      // Re-apply styles if shadow DOM is updated
      styleNonCoverageButton();

      // Check if view cart button needs to be re-added (if checkout+ app cleared it)
      const existingViewCart =
        checkoutButtonsContainer.querySelector('a[href*="/cart"]');

      if (!existingViewCart && viewCartButton) {
        console.log('View cart button missing, re-inserting...');
        const clonedViewCart = viewCartButton.cloneNode(true);
        clonedViewCart.classList.remove('button--full');
        clonedViewCart.style.cssText = `
          width: auto !important;
          flex: 1 1 50% !important;
          min-width: 0 !important;
          display: inline-block !important;
        `;

        try {
          checkoutButtonsContainer.insertBefore(
            clonedViewCart,
            checkoutButtonsContainer.firstChild
          );

          // Re-apply flexbox styles
          checkoutButtonsContainer.style.cssText += `
            display: flex !important;
            flex-direction: row !important;
            gap: 1.2rem !important;
            width: 100% !important;
          `;
          console.log('View cart button re-inserted');
        } catch (error) {
          console.error('Error re-inserting view cart button:', error);
        }
      }
    });

    shadowDOMObserver.observe(shadowRoot, {
      childList: true,
      subtree: true,
    });

    // Watch for non-coverage button specifically
    const nonCoverageObserver = new MutationObserver(() => {
      styleNonCoverageButton();
    });

    nonCoverageObserver.observe(shadowRoot, {
      childList: true,
      subtree: true,
    });
  } catch (error) {
    console.warn('Could not restructure checkout+ layout:', error);
  }
}

// Initialize on load
document.addEventListener('DOMContentLoaded', () => {
  initializeCheckoutForm();
  restructureCheckoutPlus();
});

// Observe cart drawer for changes
const cartDrawerElement = document.querySelector('cart-drawer');
if (cartDrawerElement) {
  observer.observe(cartDrawerElement, {
    childList: true,
    subtree: true,
  });

  // Initialize checkout form when drawer opens
  setTimeout(() => {
    initializeCheckoutForm();
    restructureCheckoutPlus();
  }, 100);
}

// Also observe for checkout+ app insertion and cart drawer visibility
const checkoutPlusObserver = new MutationObserver(() => {
  restructureCheckoutPlus();
});

if (cartDrawerElement) {
  checkoutPlusObserver.observe(cartDrawerElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class'],
  });

  // Watch for cart drawer opening
  const visibilityObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class'
      ) {
        const isVisible =
          cartDrawerElement.classList.contains('is-visible') ||
          document.querySelector('cart-drawer.is-visible');
        if (isVisible) {
          // Delay to ensure checkout+ app has loaded
          setTimeout(() => {
            restructureCheckoutPlus();
          }, 500);
        }
      }
    });
  });

  visibilityObserver.observe(cartDrawerElement, {
    attributes: true,
    attributeFilter: ['class'],
  });

  // Also observe the cart-drawer element inside
  const innerDrawer = document.querySelector('.cart-drawer__inner');
  if (innerDrawer) {
    visibilityObserver.observe(innerDrawer.parentElement || cartDrawerElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  // Try immediately and then repeatedly
  setTimeout(() => restructureCheckoutPlus(), 100);
  setTimeout(() => restructureCheckoutPlus(), 500);
  setTimeout(() => restructureCheckoutPlus(), 1000);
  setTimeout(() => restructureCheckoutPlus(), 2000);
}
